function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#e4761b;stroke:none}.st1,.st10{stroke: none}.st2{fill:#763d16}.st2,.st3,.st4,.st5,.st6,.st7,.st8{}.st3{fill:#f6851b}.st4{fill:#e2761b;}.st5{fill:#cd6116;}.st6{fill:#c0ad9e;stroke:#c0ad9e}.st7{fill:#d7c1b3;stroke:#d7c1b3}.st8{fill:#e4751f;stroke:#e4751f}.st10{fill:#161616;stroke:#161616}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#161616",
  stroke: "#161616",
  d: "M277.3 145.6l-5-3.6 8-7.3-6.1-4.8 8-6.1-5.3-4 8.4-40.8-12.6-37.9-81.1 30.3h-67.5L43 41.1 30.4 79l8.5 40.8-5.4 4 8 6.1-6.1 4.8 8 7.3-5 3.6 11.5 13.5-17.4 54.2 16.1 55.3 56.7-15.6 11 9 22.4 15.5H177l22.4-15.5 11-9 56.7 15.6 16.2-55.3-17.5-54.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M105.3 253l-56.7 15.6-16.1-55.3zm178-39.7l-16.2 55.3-56.7-15.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M265.8 159.1l-52.3-15.3 18.3-4.8zm-215.9 0L84 139l18.2 4.8zM43.4 142l-1.9-12.1L84 139z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M272.3 142l-40.5-3 42.4-9.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M272.3 142l-6.5 17.1-34-20.1zm-228.9 0l40.6-3-34.1 20.1zm188.4-3l45.1-19.2-2.7 10.1zM84 139l-42.5-9.1-2.6-10.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M124.1 71.4h67.5l-15.1 41.1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M176.5 112.5h-37.3l-15.1-41.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M276.9 119.8L231.8 139l-.8-51.6zm-174.7 24L84 139l.7-51.6z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M84.7 87.4L84 139l-45.1-19.2zm146.3 0l.8 51.6-18.3 4.8z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.2 112.5L43 41.1l81.1 30.3z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M272.7 41.1l-96.2 71.4 15.1-41.1z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M210.4 253l26.5-39.7h46.4zM32.5 213.3h46.4l26.4 39.7z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M229.3 167.7l54 45.6h-46.4zm-142.9 0l-53.9 45.6 17.4-54.2zm-7.5 45.6H32.5l53.9-45.6z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M229.3 167.7l36.5-8.6 17.5 54.2z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M84.7 87.4l54.5 25.1-37 31.3zm128.8 56.4l-37-31.3L231 87.4zm52.3 15.3l6.5-17.1 5 3.6zm-215.9 0l-11.5-13.5 5-3.6zM272.3 142l1.9-12.1 6.1 4.8zm-228.9 0l-8-7.3 6.1-4.8z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M33.5 123.8l5.4-4 2.6 10.1zm248.7 0l-8 6.1 2.7-10.1z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M49.9 159.1l52.3-15.3-15.8 23.9zm215.9 0l-36.5 8.6-15.8-23.9z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M38.9 119.8L30.4 79l54.3 8.4zM231 87.4l54.3-8.4-8.4 40.8z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M102.2 143.8l37-31.3 3.4 57.7zm111.3 0l15.8 23.9-56.2 2.5zm-40.4 26.4l3.4-57.7 37 31.3z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M142.6 170.2l-56.2-2.5 15.8-23.9z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M272.7 41.1L285.3 79 231 87.4zM43 41.1l96.2 71.4-54.5-25.1zm188 46.3l-54.5 25.1 96.2-71.4z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M84.7 87.4L30.4 79 43 41.1z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M105.3 253l-26.4-39.7 31.1.4zm105.1 0l-4.7-39.3 31.2-.4z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M173.1 170.2h-30.5l-3.4-57.7z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M139.2 112.5h37.3l-3.4 57.7z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M116.3 262l-11-9 31.5 14.9zm62.6 5.9l31.5-14.9-11 9z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M136.6 258.6l.2 9.3-31.5-14.9zm42.6 0l31.2-5.6-31.5 14.9z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M86.4 167.7l23.6 46-31.1-.4zm150.5 45.6l-31.2.4 23.6-46z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M86.4 167.7l22.8 23.1.8 22.9zm142.9 0l-23.6 46 .9-22.9z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M105.3 253l33.9-16.5-2.6 22.1zm105.1 0l-31.2 5.6-2.7-22.1z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.2 236.5L105.3 253l4.7-39.3zm37.3 0l29.2-22.8 4.7 39.3z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M173.1 170.2l56.2-2.5-22.7 23.1zm-63.9 20.6l-22.8-23.1 56.2 2.5z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M142.6 170.2l-13.5 11.5-19.9 9.1zm64 20.6l-20-9.1-13.5-11.5z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M205.7 213.7l-27.4-14.6 28.3-8.3zm-95.7 0l-.8-22.9 28.2 8.3z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M137.4 199.1l-28.2-8.3 19.9-9.1zm40.9 0l8.3-17.4 20 9.1z",
  fill: "#233447",
  stroke: "#233447",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M186.6 181.7l-8.3 17.4-5.2-28.9zm-57.5 0l13.5-11.5-5.2 28.9z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M199.4 262L177 277.5l1.9-9.6zm-62.6 5.9l1.9 9.6-22.4-15.5z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M178.3 199.1l-6.5-10.7 1.3-18.2z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M137.4 199.1l5.2-28.9 1.3 18.2z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M173.1 170.2l-1.3 18.2h-27.9z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M143.9 188.4l-1.3-18.2h30.5zm34.4 10.7l27.4 14.6-29.2 22.8zm-39.1 37.4L110 213.7l27.4-14.6z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M137.4 199.1l6.6 34.1-4.8 3.3zm39.1 37.4l-4.8-3.3 6.6-34.1z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M171.8 188.4l6.5 10.7-6.6 34.1zm-27.9 0l.1 44.8-6.6-34.1z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M143.9 188.4h27.9l-.1 44.8zm27.8 44.8H144l-.1-44.8z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M179.2 258.6l-.3 9.3-1.9 9.6zm-40.5 18.9l-1.9-9.6-.2-9.3z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M136.6 258.6l2.4-2.2-.3 21.1zm40.4 18.9l-.3-21.1 2.5 2.2z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M138.7 277.5l.3-21.1h37.7zm38-21.1l.3 21.1h-38.3z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.5 236.5l2.7 22.1-2.5-2.2zM139 256.4l-2.4 2.2 2.6-22.1zm.2-19.9l1.5 4.7-1.7 15.2z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.7 256.4l-1.7-15.2 1.5-4.7zm-33-18.7l-3 3.5-1.5-4.7z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.5 236.5l-1.5 4.7-3-3.5z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M172 237.7l-.3-4.5 4.8 3.3zm-32.8-1.2l4.8-3.3-.3 4.5z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M171.7 233.2l.3 4.5h-28.3z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143.7 237.7l.3-4.5h27.7zm-3 3.5H175l1.7 15.2z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.7 256.4H139l1.7-15.2zm-36-15.2l3-3.5H172z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M172 237.7l3 3.5h-34.3z"
});

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 318.6 318.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.2eeaab62.svg";
export { ForwardRef as ReactComponent };